import React, { useEffect, useState } from 'react';
import './OdHeader.scss';
import { useDispatch, useSelector } from 'react-redux';
import Logo from './Logo/Logo';
import NavLinks from './NavLinks/NavLinks';
import NavActions from './NavActions/NavActions';
import Banner from './Banner/Banner';
import { getMainNav } from '../../../actionCreators/header';

const OdHeader = props => {
  const navigation = useSelector(state => state?.header?.mainNavigationData?.navigation);
  const dispatch = useDispatch();
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);

  useEffect(() => {
    dispatch(getMainNav());
  }, []);

  useEffect(() => {
    console.log('this is navigation desktop===>', navigation);
  }, [navigation]);

  useEffect(() => {
    const handleScroll = () => {
      // Adjust 50 to your banner's height in px
      setIsHeaderFixed(window.scrollY > 48);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (navigation && Array.isArray(navigation) && navigation.length > 0) {
    return (
      <>
        <Banner />
        {isHeaderFixed && <div style={{ height: 67 }}></div>}
        <header className={`odHeader${isHeaderFixed ? ' odHeader--fixed' : ''}`}>
          <Logo />
          <NavLinks />
          <NavActions {...props} />
        </header>
      </>
    );
  }

  return null;
};

export default OdHeader;
